var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._l((_vm.props.statuses || _vm.props.status),function(item,index){return _c('row',{key:index,attrs:{"appearance":"nowrap","space":"xs"}},[_c('cell',[_c('span',[_vm._v(_vm._s(item.title))])])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }